/**
 * Definición de campos del form de Configuración General.
 * Secciones:
 *  1) Identidad y datos de la empresa (editables)
 *  2) Plantillas de mensaje (editables, marcadas "para uso futuro")
 *
 * El logo se maneja aparte (upload separado con R2).
 */

export const COMPANY_FIELDS = [
  { id: 'nombreComercial', label: 'Nombre comercial', type: 'text', maxLength: 160 },
  { id: 'razonSocial', label: 'Razón social', type: 'text', maxLength: 160 },
  { id: 'nit', label: 'NIT', type: 'text', maxLength: 40, placeholder: '900123456' },
  {
    id: 'direccion',
    label: 'Dirección',
    type: 'text',
    maxLength: 255,
    placeholder: 'Calle 100 #15-20, Bogotá',
  },
  {
    id: 'telefono',
    label: 'Teléfono',
    type: 'text',
    maxLength: 40,
    placeholder: '+57 300 000 0000',
  },
  {
    id: 'correo',
    label: 'Correo de contacto',
    type: 'email',
    maxLength: 160,
    placeholder: 'contacto@empresa.com',
  },
  {
    id: 'sitioWeb',
    label: 'Sitio web',
    type: 'text',
    maxLength: 255,
    placeholder: 'https://empresa.com',
  },
];

export const TEMPLATE_FIELDS = [
  {
    id: 'encabezadoEmbarque',
    label: 'Encabezado para embarques',
    rows: 3,
    placeholder: 'Texto que aparecerá arriba en documentos de embarque…',
    helper: 'Aparece en la parte superior de los documentos de embarque.',
  },
  {
    id: 'pieEmbarque',
    label: 'Pie para embarques',
    rows: 3,
    placeholder: 'Texto al pie de los documentos de embarque…',
  },
  {
    id: 'encabezadoFactura',
    label: 'Encabezado para facturas',
    rows: 3,
    placeholder: 'Encabezado de facturas…',
  },
  {
    id: 'pieFactura',
    label: 'Pie para facturas',
    rows: 3,
    placeholder: 'Pie de facturas…',
  },
  {
    id: 'encabezadoCorreo',
    label: 'Encabezado para correos',
    rows: 3,
    placeholder: 'Encabezado de correos automáticos…',
  },
  {
    id: 'pieCorreo',
    label: 'Pie para correos',
    rows: 3,
    placeholder: 'Pie de correos automáticos…',
  },
];
